export const AMPLITUDE = {
  GENERAL_REPORT: 'General Report',
  GENERAL_REPORT_SEND: 'Send Report',
  GENERAL_REPORT_SUCCESS: 'success',
  GENERAL_REPORT_FAILED: 'failed',
};
